import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getList = async (
    industryId: string,
    page = 1,
    per_page = 10,
    search_string = '',
    sort_by = 'name',
    sort_order: 'ASC' | 'DESC' = 'ASC'
) => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
        });
        if (search_string) params.append('search_string', search_string);
        let res = await ServiceWrapper.doGet(
            `${api_base_url}industry/${industryId}/list?${params.toString()}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return res;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getListItem = async (id: string) => {
    try {
        let res = await ServiceWrapper.doGet(
            `${api_base_url}list/${id}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return res;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const saveList = async (requestBody: any) => {
    try {
        let res = await ServiceWrapper.doPost(
            `${api_base_url}list`,
            requestBody,
            null,
            AuthManager.getGmsToken()
        );
        return res;
    } catch (error) {
        console.log(error);
        return null;
    }

};

export const updateList = async (requestBody: any, id: string) => {
    try {
        let res = await ServiceWrapper.doPut(
            `${api_base_url}list/${id}`,
            requestBody,
            null,
            AuthManager.getGmsToken()
        );
        return res;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const deleteListItem = async (id: string) => {
    try {
        const res = await ServiceWrapper.doDelete(
            `${api_base_url}list/${id}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        if (!res?.errorfound) return true
    } catch (error) {
        return false
    }
}

export const copyListItem = async (id: string, name: string) => {
    try {
        const req = {
            id: id,
            name: name
        };
        const res = await ServiceWrapper.doPost(
            `${api_base_url}list/copy`,
            req,
            null,
            AuthManager.getGmsToken()
        );
        if (!res?.errorfound) return res?.data;
    } catch (error) {
        return false
    }
}

export const exportList = async (listId: string) => {
    try {
        const res = await ServiceWrapper.doGet(
            `${api_base_url}list/${listId}/export`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return res?.data;
    } catch (error) {
        return "could'nt export list";
    }
};

export const validateList = async (file: File) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await ServiceWrapper.doPost(
            `${api_base_url}list/validate`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return res?.data;
    } catch (error) {
        return "could'nt validate list";
    }
};

export const importList = async (industryId: string, listId: string, file: File) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await ServiceWrapper.doPost(
            `${api_base_url}industry/${industryId}/list/${listId}/import`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return res?.data;
    } catch (error) {
        return "could'nt import list";
    }
};

export const transferListOwner = async (listId: string, userId: string, username: string) => {
    try {
        const res = await ServiceWrapper.doPut(
            `${api_base_url}list/${listId}/transfer_ownership`,
            { userid: userId, username },
            null,
            AuthManager.getGmsToken()
        );
        return res?.data;
    } catch (error) {
        return null;
    }
};